export default "__VITE_ASSET__npaM1eRL__"